
const LOGOS = {
  cb: {
    src: require('~/assets/images/payment_cb.png'),
    alt: 'CB',
    height: 'tw-h-6',
  },
  visa: {
    src: require('~/assets/images/payment_visa.png'),
    alt: 'Visa',
    height: 'tw-h-4',
  },
  mastercard: {
    src: require('~/assets/images/payment_mastercard.svg'),
    alt: 'Mastercard',
    height: 'tw-h-8',
  },
  paypal: {
    src: require('~/assets/images/payment_paypal2.png'),
    alt: 'PayPal',
    height: 'tw-h-4',
  },
  apple_pay: {
    src: require('~/assets/images/payment_apple_pay2.png'),
    alt: 'Apple Pay',
    height: 'tw-h-5',
  },
  google_pay: {
    src: require('~/assets/images/payment_google_pay2.png'),
    alt: 'Google Pay',
    height: 'tw-h-5',
  },
  oney: {
    src: require('~/assets/images/payment_oney.png'),
    alt: 'Oney',
    height: 'tw-h-5',
  },
}

export default {
  name: 'PaymentLogos',
  props: {
    tiles: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logos() {
      return this.$store.getters.payment_offers.logos
        .filter(id => LOGOS[id])
        .map(id => ({ id, ...LOGOS[id] }))
    },
  },
}
